import React, { FC } from "react"
import { Spacer } from "./styles"
import { SpacerProps } from "./types"

const Spacing: FC<SpacerProps> = ({
    size,
    css
}) => {
    return <Spacer css={css} size={size} />
}

export default Spacing
